import React from 'react';
import '../App.css';
import './PageStyles.css';

const Matches = () => {
    // Sample match data for blurred preview
    const sampleMatches = [
        {
            id: 1,
            name: 'Premium Textile Solutions Inc.',
            description: 'Leading manufacturer of sustainable fabrics with certifications in organic cotton and recycled materials',
            industry: 'Textiles & Apparel',
            location: 'New York, USA',
            matchScore: 95
        },
        {
            id: 2,
            name: 'Global Color Innovations',
            description: 'Specialized in custom color matching and dye solutions for large-scale production',
            industry: 'Chemical Manufacturing',
            location: 'London, UK',
            matchScore: 92
        },
        {
            id: 3,
            name: 'EcoFiber Manufacturing Co.',
            description: 'Sustainable fiber production with focus on circular economy and zero-waste processes',
            industry: 'Sustainable Materials',
            location: 'Amsterdam, Netherlands',
            matchScore: 88
        },
        {
            id: 4,
            name: 'Advanced Dye Technologies',
            description: 'Innovative dyeing solutions with water-saving technologies and eco-friendly formulations',
            industry: 'Chemical Manufacturing',
            location: 'Tokyo, Japan',
            matchScore: 87
        },
        {
            id: 5,
            name: 'Textile Excellence Group',
            description: 'Full-service textile provider with global supply chain and quality assurance',
            industry: 'Textiles & Apparel',
            location: 'Milan, Italy',
            matchScore: 85
        },
        {
            id: 6,
            name: 'Sustainable Color Partners',
            description: 'Boutique color consultancy specializing in natural dyes and sustainable practices',
            industry: 'Consulting',
            location: 'Portland, USA',
            matchScore: 83
        }
    ];

    return (
        <>
            <main className="App-main">
                <section className="page-hero">
                    <div className="page-hero-content">
                        <h1 className="page-hero-title">Your Matches</h1>
                        <p className="page-hero-subtitle">
                            We're working on finding your perfect matches
                        </p>
                    </div>
                </section>

                <section className="value-props-section">
                    <div className="value-props-container">
                        {/* Blurred Match Cards Preview */}
                        <div className="relative max-w-content mx-auto px-8">
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {sampleMatches.map((match) => (
                                    <div
                                        key={match.id}
                                        className="bg-card rounded-lg shadow-sm border border-border overflow-hidden"
                                        style={{
                                            position: 'relative',
                                            filter: 'blur(4px)',
                                            opacity: 0.6,
                                            pointerEvents: 'none',
                                            userSelect: 'none'
                                        }}
                                    >
                                        {/* Match Header */}
                                        <div className="px-6 py-5 bg-gradient-to-r from-brand-orange-muted to-brand-purple/10 border-b border-border">
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-start',
                                                marginBottom: '0.75rem'
                                            }}>
                                                <h3 className="text-xl font-semibold text-foreground" style={{
                                                    fontSize: '1.25rem',
                                                    fontWeight: 600,
                                                    color: 'var(--color-text-heading)',
                                                    margin: 0
                                                }}>
                                                    {match.name}
                                                </h3>
                                                <div className="px-2 py-0.5 rounded-md text-xs font-semibold bg-brand-orange-muted text-brand-orange font-ui">
                                                    {match.matchScore}%
                                                </div>
                                            </div>
                                            <p className="text-sm text-muted-foreground line-clamp-2" style={{
                                                fontSize: '0.875rem',
                                                color: 'var(--color-text-secondary)',
                                                margin: 0,
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden'
                                            }}>
                                                {match.description}
                                            </p>
                                        </div>

                                        {/* Match Details */}
                                        <div className="px-6 py-5 space-y-3" style={{
                                            padding: '1.25rem 1.5rem',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '0.75rem'
                                        }}>
                                            <div className="flex items-start">
                                                <span className="text-muted-foreground mr-2 text-sm">🏭</span>
                                                <div className="flex-1">
                                                    <div className="text-xs text-muted-foreground uppercase tracking-wide mb-1" style={{
                                                        fontSize: '0.75rem',
                                                        color: 'var(--color-text-secondary)',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.05em',
                                                        marginBottom: '0.25rem'
                                                    }}>
                                                        Industry
                                                    </div>
                                                    <div className="text-foreground text-sm" style={{
                                                        fontSize: '0.875rem',
                                                        color: 'var(--color-text-primary)'
                                                    }}>
                                                        {match.industry}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex items-start">
                                                <span className="text-muted-foreground mr-2 text-sm">📍</span>
                                                <div className="flex-1">
                                                    <div className="text-xs text-muted-foreground uppercase tracking-wide mb-1" style={{
                                                        fontSize: '0.75rem',
                                                        color: 'var(--color-text-secondary)',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.05em',
                                                        marginBottom: '0.25rem'
                                                    }}>
                                                        Location
                                                    </div>
                                                    <div className="text-foreground text-sm" style={{
                                                        fontSize: '0.875rem',
                                                        color: 'var(--color-text-primary)'
                                                    }}>
                                                        {match.location}
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{
                                                marginTop: '0.5rem',
                                                padding: '0.75rem',
                                                backgroundColor: 'var(--color-bg-secondary)',
                                                borderRadius: '0.375rem',
                                                border: '1px solid var(--color-border)'
                                            }}>
                                                <div className="text-xs text-muted-foreground uppercase tracking-wide mb-2" style={{
                                                    fontSize: '0.75rem',
                                                    color: 'var(--color-text-secondary)',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em',
                                                    marginBottom: '0.5rem'
                                                }}>
                                                    Match Reasons
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '0.5rem'
                                                }}>
                                                    <span className="px-2 py-0.5 rounded text-xs font-ui font-medium bg-brand-orange-muted text-brand-orange">
                                                        Compatible Products
                                                    </span>
                                                    <span className="px-2 py-0.5 rounded text-xs font-ui font-medium bg-brand-orange-muted text-brand-orange">
                                                        Similar Values
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Overlay Message */}
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                textAlign: 'center',
                                backgroundColor: 'var(--color-card-bg)',
                                padding: '2rem 3rem',
                                borderRadius: '0.75rem',
                                border: '2px solid var(--color-primary-orange)',
                                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
                                zIndex: 10,
                                maxWidth: '500px',
                                width: '90%'
                            }}>
                                <div style={{
                                    fontSize: '3rem',
                                    marginBottom: '1rem'
                                }}>
                                    🔒
                                </div>
                                <h3 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: 600,
                                    color: 'var(--color-text-heading)',
                                    marginBottom: '0.5rem'
                                }}>
                                    Matches Coming Soon
                                </h3>
                                <p style={{
                                    fontSize: '1rem',
                                    color: 'var(--color-text-secondary)',
                                    lineHeight: '1.6',
                                    margin: 0
                                }}>
                                    Your personalized matches are being prepared. Check back soon to see your top connections!
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default Matches;

